/**
 * Column definitions for Deduction Approval expandable table
 */

// Column definitions for the nested deduction breakdown table (per-driver expand)
export const getDeductionBreakdownColumns = () => [
  { id: "date",            label: "Date",             width: "15%" },
  { id: "amount",          label: "Transaction Amount",  width: "15%" },
  { id: "type",            label: "Deduction Type",    width: "15%" },
  { id: "transactionType", label: "Transaction Type",  width: "15%" },
  { id: "tripCount",       label: "Trip Count",        width: "15%" },
];

// Column definitions for the main Deduction Approval table
// Note: checkbox and expand arrow are merged with driverName column in the UI
export const DEDUCTION_APPROVAL_COLUMNS = [
  { id: "driverName",           label: "Driver Name",             width: "14%" },
  { id: "cabNo",                label: "Cab No.",                 width: "14%" },
  { id: "period",               label: "Period",                  width: "17%" },
  { id: "walletBalance",        label: "Current Wallet Balance",  width: "11%" },
  { id: "totalDeductionAmount", label: "Transaction Amount",            width: "10%" },
  { id: "settlementAction", label: "Transaction Type", width: "8%" },
  { id: "expectedWalletBalance",label: "Expected Wallet Balance",        width: "13%" },
  { id: "status",               label: "Status",                  width: "8%" },
];

// Column definitions for the Deduction Run (job list) table
export const DEDUCTION_RUN_COLUMNS = [
  // { id: "settlementPeriod", label: "Settlement Period", width: "15%" },
  { id: "initiatedByName",  label: "Initiated By",      width: "13%" },
  { id: "initiatedAt",      label: "Initiated At",      width: "14%" },
  { id: "completedAt",      label: "Completed At",      width: "14%" },
  { id: "totalDrivers",     label: "Total Drivers",     width: "8%"  },
  { id: "processedCount",   label: "Processed",         width: "8%"  },
  { id: "failedCount",      label: "Failed",            width: "7%"  },
  // { id: "totalAmount",      label: "Transaction Amount",      width: "10%" },
  { id: "status",           label: "Status",            width: "10%" },
];
